import { render } from "./CardSwitch.vue?vue&type=template&id=947ddc1a"
import script from "./CardSwitch.vue?vue&type=script&lang=js"
export * from "./CardSwitch.vue?vue&type=script&lang=js"

import "./CardSwitch.vue?vue&type=style&index=0&id=947ddc1a&lang=css"

import exportComponent from "D:\\fclinique\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__